import { Popconfirm } from 'antd';
import StatusSwitch, { StatusSwitchProps } from 'components/StatusSwitch';
import { useState, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { detectConflict, fetchMarketingTask } from 'services/api/oms';
import { isConfictScenarioType } from '../Scenario/config';

export type ConflictSwitchProps = StatusSwitchProps &
  Util.RequireAtLeastOne<{ taskId: number; stores: Marketing.TaskStore[] }> & {
    platform: General.PlatformUpperCase;
    region?: General.UpperCaseRegion;
    scenarioType: Marketing.AllScenarioType;
  };

function ConflictSwitch(props: ConflictSwitchProps) {
  const { platform, region, scenarioType, taskId, stores, onChange, ...otherProps } = props;

  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);
  const checkedRef = useRef(false);

  return (
    <Popconfirm
      placement="top"
      visible={visible}
      title={
        <div>
          {scenarioType === 'PRAISE_REMINDER'
            ? t('aide.检测到已配置买家签收后，发送已签收话术。')
            : t('aide.检测到已配置买家签收后，发送催好评话术。')}
          <br />
          {t('aide.买家签收后，系统会同时发送催好评、已签收话术。')}
        </div>
      }
      onCancel={() => setVisible(false)}
      onConfirm={(e) => {
        setVisible(false);
        onChange(checkedRef.current, e as any);
      }}
    >
      <StatusSwitch
        {...otherProps}
        onChange={(checked, e) => {
          if (!checked || !region || !isConfictScenarioType(scenarioType)) {
            return onChange(checked, e);
          }

          checkedRef.current = checked;

          return (
            stores
              ? Promise.resolve(stores)
              : fetchMarketingTask(taskId as number).then((task) => {
                  const { praiseTriggerPoint, stores } = task;

                  if (scenarioType === 'PRAISE_REMINDER' && praiseTriggerPoint !== 'SIGNED') {
                    return Promise.reject(new Error('Not need detect.'));
                  }

                  return stores;
                })
          )
            .then((stores) => {
              return detectConflict({
                platform,
                region,
                scenarioType,
                stores,
              });
            })
            .then(({ hasConflict }) => {
              if (hasConflict) {
                setVisible(true);
              } else {
                onChange(checked, e);
              }
            })
            .catch(() => {
              onChange(checked, e);
            });
        }}
      />
    </Popconfirm>
  );
}

export default ConflictSwitch;
